export const DESKTOP_BREAKPOINT = `@media only screen and (min-width: 992px)`;
export const BASE_URL =
  'https://61ea356d7bc0550017bc65c1.mockapi.io/api/shipper/driver';
